import { ref } from 'vue'
import { useHost } from './useHost'
// import { useIntervalFn } from '@vueuse/core'

/**
 * 检测更新间隔
 */
const DURATION = 2 * 60 * 1000

// let lastScripts: string[] = []

const needUpdate = ref<boolean>(false)
const curVersion = ref<string>('')
/**
 * 设置需要更新的状态
 * @param val
 */
const setNeedUpdate = (val: boolean) => {
  needUpdate.value = val
}

/**
 * 检测脚本src
 * @param html
 * @returns
 */
// const extractNewScripts = (html: string): string[] => {
//   const scriptReg = /<script.*src=["'](?<src>[^"']+)/gm
//   const result: string[] = []

//   let match
//   while ((match = scriptReg.exec(html))) {
//     result.push(match.groups?.src ?? '')
//   }

//   return result
// }

/**
 * 检测更新
 * @returns
 */
const checkUpdate = async (): Promise<boolean> => {
  
  if(useHost().isLocal()) return false
  console.log('checkUpdate')
  try {
    const versionJson = await fetch('/version.json?r=' + Date.now()).then((resp) => resp.text())
    const verInfo:{ver:string} = JSON.parse(versionJson)
    // console.log('检测到版本',verInfo)
    //判断版本
    if(verInfo.ver!=curVersion.value){
      console.log('提示更新版本',curVersion.value,verInfo)
      // console.log('提示更新版本',verInfo)
      setNeedUpdate(true)
      return true
    }
    return false
  } catch (err) {
    return false
  }
}

const install = (ver:string) => {
  curVersion.value = ver
  checkUpdate()
}

const doUpdate = () => {
  window.location.reload()
}

setInterval(() => {
  if (needUpdate.value) return
  checkUpdate()
}, DURATION)

export const useUpdate = () => ({ needUpdate, setNeedUpdate, install, doUpdate,curVersion })
